import { render, staticRenderFns } from "./formation.vue?vue&type=template&id=2227da6b&"
import script from "./formation.vue?vue&type=script&lang=js&"
export * from "./formation.vue?vue&type=script&lang=js&"
import style0 from "./formation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports